export const FETCHING_SHOOTS = "FETCHING_SHOOTS";
export const FAILED_FETCHING_SHOOTS = "FAILED_FETCHING_SHOOTS";
export const DONE_FETCHING_SHOOTS = "DONE_FETCHING_SHOOTS";
export const RESET_SHOOTS = "RESET_SHOOTS";

export const SHOOT_GET_SELECTED = "SHOOT_GET_SELECTED"
export const SHOOT_DONE_FETCHING_SELECTED = "SHOOT_DONE_FETCHING_SELECTED"
export const SHOOT_FAILED_FETCHING_SELECTED = "SHOOT_FAILED_FETCHING_SELECTED"

export const SHOOT_CLEAR = "SHOOT_CLEAR"